import { render, staticRenderFns } from "./roleAuthForm.vue?vue&type=template&id=eb1ba5fc&scoped=true"
import script from "./roleAuthForm.vue?vue&type=script&lang=js"
export * from "./roleAuthForm.vue?vue&type=script&lang=js"
import style0 from "./roleAuthForm.vue?vue&type=style&index=0&id=eb1ba5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1ba5fc",
  null
  
)

export default component.exports